var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-page-detail"},[_c('FileInfo',{attrs:{"params":_vm.baseFileInfo,"space-id":_vm.spaceId,"isHistoryVersion":_vm.isHistoryVersion}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }